import * as ss from 'superstruct';
import { BrandAssetDto } from './brand-asset';
import { BrandKitCompleteFields, BrandKitFields } from './brand-kit-field';

/** Backend route for the active org's brand kit. */
export const BrandKitApiPath = '/api/brand-kit';

export const BrandKitChangeNoteMaxLength = 1000;

export const BrandKitVersionDto = ss.type({
  id: ss.integer(),
  /** Absent for the draft. */
  versionNumber: ss.optional(ss.integer()),
  fields: BrandKitFields,
  changeNote: ss.optional(ss.string()),
  /** Increments on every draft save; echo it back to detect concurrent edits. */
  revision: ss.integer(),
  /** Name or email of whoever last saved the draft or published the version. */
  updatedBy: ss.optional(ss.string()),
  updatedAt: ss.string(),
  publishedAt: ss.optional(ss.string()),
  /** The assets `fields` use. */
  assets: ss.array(BrandAssetDto),
});

export type BrandKitVersionDto = ss.Infer<typeof BrandKitVersionDto>;

export const BrandKitActiveResponse = ss.type({
  /** The latest published version; absent if none has been published. */
  version: ss.optional(BrandKitVersionDto),
});

export type BrandKitActiveResponse = ss.Infer<typeof BrandKitActiveResponse>;

export const BrandKitVersionSummary = ss.type({
  versionNumber: ss.integer(),
  changeNote: ss.optional(ss.string()),
  updatedBy: ss.optional(ss.string()),
  publishedAt: ss.string(),
});

export type BrandKitVersionSummary = ss.Infer<typeof BrandKitVersionSummary>;

export const BrandKitVersionSummaries = ss.array(BrandKitVersionSummary);

/** Identifies the draft as the caller last saw it. */
const draftRef = {
  id: ss.integer(),
  revision: ss.integer(),
};

export const BrandKitDraftRef = ss.object(draftRef);

export type BrandKitDraftRef = ss.Infer<typeof BrandKitDraftRef>;

export const BrandKitSaveDraftRequest = ss.object({
  ...draftRef,
  fields: BrandKitCompleteFields,
});

export type BrandKitSaveDraftRequest = ss.Infer<
  typeof BrandKitSaveDraftRequest
>;

export const BrandKitPublishRequest = ss.object({
  ...draftRef,
  changeNote: ss.optional(ss.size(ss.string(), 0, BrandKitChangeNoteMaxLength)),
});

export type BrandKitPublishRequest = ss.Infer<typeof BrandKitPublishRequest>;
